// React and core libraries
import * as React from "react";
import {
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";

// Third-party libraries
import { useQuery } from "react-query";

// Internal components
import { Page } from "../../components/layout/page";
import { Overview } from "./Overview";
import { ClusterRouter } from "./ClusterRouter";

// Internal utilities, hooks, and contexts
import { ApiClient } from "../../apiUtils";
import { Urls } from "../../domain/urls";
import { useScopedContext } from "../../shared-components/ScopeSelector";

const SuperLegacyClusterRedirect = (): React.ReactElement => {
  const clusterId = useParams().clusterId as string;

  const { isLoading, data } = useQuery(["fetchCluster", clusterId], () =>
    ApiClient.declarativeViewsClusterClusterGetByIdForFrontend({
      pk: Number(clusterId),
    }),
  );

  const path = useLocation();

  if (isLoading) {
    return <></>;
  }

  const account = data?.account.slug;
  if (account) {
    const regex = /\/clusters\/(\d+).*/;
    // Replace the matched pattern with the new structure, inserting `someVar` in the specified position
    const newPath = path.pathname.replace(
      regex,
      `/clusters/$1/account/${account}/information`,
    );
    return <Navigate to={newPath} replace />;
  } else {
    // we couldn't determine account for this cluster ID, so redirect to list of clusters
    return <Navigate to={`/${Urls.Clusters}`} replace />;
  }
};

export const ClustersRouter = (): React.ReactElement => {
  const [scope] = useScopedContext();
  const breadCrumbs = React.useMemo(() => [{ text: "Clusters" }], []);

  return (
    <Routes>
      <Route
        path="/:clusterId/account/:accountSlug/*"
        element={<ClusterRouter />}
      />
      <Route path="/:clusterId/*" element={<SuperLegacyClusterRedirect />} />
      <Route
        path=""
        element={
          <Page
            title={`Coiled Dashboard (${scope.name})`}
            breadCrumbs={breadCrumbs}
          >
            <Overview />
          </Page>
        }
      />
    </Routes>
  );
};
